<template>
    <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">イベントの確認</h4>
            <h5>直近5件のイベントを表示しています。</h5>
        </div>
        <div class="modal-body">
            <table class="table">
                <thead>
                    <tr>
                    <th>#</th>
                    <th>タイトル</th>
                    <th>場所</th>
                    <th>開始日時</th>
                    <th>終了日時</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="this.calendars.length == 0">
                        <td colspan="5" id="empty-message">
                            <span>カレンダーに予定がありません。</span>
                        </td>
                    </tr>
                    <tr v-else v-for="(cal, i) in limit10Calendars" :key="i">
                        <td scope="row">{{ i + 1 }}</td>
                        <td>{{ cal.summary }}</td>
                        <td>{{ cal.location }}</td>
                        <td>{{ cal.startDateTime }}</td>
                        <td>{{ cal.endDateTime }}</td>
                    </tr>
                </tbody>
            </table>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal()">キャンセル</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="saveCalendarData()">決定</button>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
    
    export default {
        props: {
            calendars: Array
        },
        methods: {
            closeModal: function() {
                let that = this
                that.$emit('close-modal')
            },
            saveCalendarData: function() {
                let that = this
                that.$emit('save-calendar-data')
            }
        },
        computed: {
            limit10Calendars: function() {
                return this.calendars.slice(0, 5)
            }
        }
    }
</script>

<style>
    .modal {
        display: block;
    }
    #empty-message {
        text-align: center;
    }
</style>
